module.exports = __webpack_public_path__ + "static/img/bg_basic.d8091493.png";